// src/pages/Users/Inscription/components/InscriptionHero.jsx

import React from "react";
import {
  FaCalendarAlt,
  FaCheckCircle,
  FaLayerGroup,
  FaUserPlus,
} from "react-icons/fa";

export default function InscriptionHero({ userInfo, saisonActive }) {
  return (
    <section className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white/90 shadow-2xl backdrop-blur-xl dark:border-white/10 dark:bg-slate-900/80">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="grid gap-8 p-6 lg:grid-cols-[1.2fr_0.8fr] lg:p-10">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full border border-indigo-200 bg-indigo-50 px-4 py-2 text-xs font-bold uppercase tracking-[0.22em] text-indigo-700 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300">
            <FaUserPlus />
            Inscription adhérent
          </div>

          <h1 className="mt-6 font-barlow text-4xl font-bold tracking-tight text-slate-950 dark:text-white sm:text-5xl">
            Inscrire un nouvel adhérent
          </h1>

          <p className="mt-4 max-w-3xl text-base leading-8 text-slate-600 dark:text-slate-300">
            Choisissez le groupe, renseignez les coordonnées, complétez les
            informations sportives puis validez l’inscription pour la saison.
          </p>

          {userInfo?.prenom || userInfo?.nom ? (
            <p className="mt-5 text-sm font-bold text-slate-700 dark:text-slate-200">
              Bienvenue {userInfo.prenom} {userInfo.nom}
            </p>
          ) : null}
        </div>

        <div className="grid gap-3 sm:grid-cols-3 lg:grid-cols-1">
          <div className="rounded-3xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950/70">
            <FaCalendarAlt className="text-indigo-600 dark:text-indigo-300" />
            <p className="mt-3 text-xs uppercase tracking-[0.18em] text-slate-500">
              Saison
            </p>
            <p className="mt-1 text-xl font-bold text-slate-950 dark:text-white">
              {saisonActive || "—"}
            </p>
          </div>

          <div className="rounded-3xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950/70">
            <FaLayerGroup className="text-[#4CA82F]" />
            <p className="mt-3 text-xs uppercase tracking-[0.18em] text-slate-500">
              Étape clé
            </p>
            <p className="mt-1 text-xl font-bold text-slate-950 dark:text-white">
              Choix du groupe
            </p>
          </div>

          <div className="rounded-3xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950/70">
            <FaCheckCircle className="text-emerald-500" />
            <p className="mt-3 text-xs uppercase tracking-[0.18em] text-slate-500">
              Validation
            </p>
            <p className="mt-1 text-xl font-bold text-slate-950 dark:text-white">
              Dossier créé
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}